@use '@/styles/tokens' as *;

// Figma radio (node 135:1811). antd paints selected as a colorPrimary disc with
// a white dot; Figma wants the inverse — white disc, dark ring, dark dot.

.radio {
  :global(.ant-radio-inner) {
    border-width: 0.5px;
  }

  &:hover :global(.ant-radio:not(.ant-radio-checked) .ant-radio-inner) {
    background: $color-neutral-100;
    border-color: $color-neutral-600;
  }

  :global(.ant-radio-checked .ant-radio-inner) {
    background: var(--surface-card);
    border-color: $color-neutral-950;
  }

  :global(.ant-radio-checked .ant-radio-inner::after) {
    background-color: $color-neutral-950;
  }
}
